import React, { useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";

import NumberInputFormControl from "../../../shared/form-controls/NumberInputFormControl";
import TextInputFormControl from "../../../shared/form-controls/TextInputFormControl";

function BuRunChargeForm({ formData, submitForm }) {
  const history = useHistory();
  const { handleSubmit, control, reset } = useForm({
    defaultValues: useMemo(() => formData, [formData]),
  });

  useEffect(() => {
    reset(formData);
  }, [formData]);

  //======================================

  return (
    <form onSubmit={handleSubmit(submitForm)} className="w-100" noValidate>
      <div className="container" style={{ textAlign: "initial" }}>
        <div className="row justify-content-md-center">
          <div className="col-md">
            <Controller
              control={control}
              name="bu"
              rules={{ required: true }}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <TextInputFormControl
                  label="BU"
                  placeholder="BU"
                  required
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={error}
                />
              )}
            />

            <Controller
              control={control}
              name="col1"
              rules={{ required: true }}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <NumberInputFormControl
                  label="Column 1"
                  placeholder="Column 1"
                  required
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={error}
                />
              )}
            />

            <Controller
              control={control}
              name="col3"
              rules={{ required: true }}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <NumberInputFormControl
                  label="Column 3"
                  placeholder="Column 3"
                  required
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={error}
                />
              )}
            />

            <Controller
              control={control}
              name="col5"
              rules={{ required: true }}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <NumberInputFormControl
                  label="Column 5"
                  placeholder="Column 5"
                  required
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={error}
                />
              )}
            />

            <Controller
              control={control}
              name="ltm"
              rules={{ required: true }}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <NumberInputFormControl
                  label="LTM"
                  placeholder="LTM"
                  required
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={error}
                />
              )}
            />

            <Controller
              control={control}
              name="runChargeType"
              rules={{ required: true }}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <TextInputFormControl
                  label="Run Charge Type"
                  placeholder="Run Charge Type"
                  required
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={error}
                />
              )}
            />
          </div>
        </div>
      </div>
      <hr />
      <div className="d-flex justify-content-center">
        <span
          className="btn btn-sm btn-danger mr-5"
          onClick={(e) => history.goBack()}
        >
          Cancel
        </span>
        <button type="submit" className="btn btn-sm btn-success">
          Save
        </button>
      </div>
    </form>
  );
}

export default BuRunChargeForm;
